import { FormFieldCorrespondingAuthor } from '@publishing-engine/domain/types/article';
import AuthorCard from './AuthorCard';
import { IAuthorWithEmail } from '@publishing-engine/domain/models';
import { useFormContext } from 'react-hook-form';

import { ISubmissionFormData } from 'src/contexts/FormContext';

import { useState } from 'react';
import { AuthorEditModal } from './AuthorEditModal';

const CorrespondingAuthor = ({
  config
}: {
  config: FormFieldCorrespondingAuthor;
}) => {
  const { setValue, watch, trigger } = useFormContext<ISubmissionFormData>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const {
    params: { labels }
  } = config;

  const authors = (watch('metadata.authors') as IAuthorWithEmail[]) || [];
  const userEmail = watch('correspondingAuthor');
  const authorsWithSubmissionUser = authors.filter(
    author => author.firstName && author.lastName && author.email
  );
  const user = authorsWithSubmissionUser.find(
    author => author.email === userEmail
  )!;
  const correspondingUser = {
    ...user,
    affiliationDetails: {
      organizationName: user?.affiliation || '',
      ringgoldId: user?.ringgoldId || ''
    }
  };
  const handleSaveChanges = async (selectedEmail: string) => {
    setValue('correspondingAuthor', selectedEmail);
    await trigger('correspondingAuthor');
    setIsEditing(false);
  };

  const handleEditClick = (isEditing: boolean) => {
    if (isEditing) {
      setIsModalOpen(true);
    } else {
      setIsEditing(isEditing);
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleModalConfirm = () => {
    setIsEditing(true);
    setIsModalOpen(false);
  };

  return (
    <>
      <AuthorCard
        title={labels.main}
        subtitle={labels.subtitle}
        isEditing={isEditing}
        showOrcid={true}
        user={{
          ...correspondingUser,
          affiliationDetails: {
            organizationName: correspondingUser.affiliation,
            country: correspondingUser.country,
            ringgoldId: correspondingUser.ringgoldId
          }
        }}
        options={authorsWithSubmissionUser.map(author => ({
          value: author.email,
          label: `${author.firstName} ${author.lastName}`
        }))}
        defaultValue={userEmail}
        onChange={handleSaveChanges}
        onEdit={handleEditClick}
      />

      {isModalOpen && (
        <AuthorEditModal
          title="Edit Corresponding Author?"
          description="This role manages important submission communications and commitments.
          Ensure consensus among all co-authors before making this change to
          avoid potential conflicts."
          onClose={handleModalClose}
          onConfirm={handleModalConfirm}
        />
      )}
    </>
  );
};

export default CorrespondingAuthor;
